/**
 * Ay kapanışı servisi.
 *
 * Her dönem (YYYY-MM) için bir doküman tutulur.
 * Doc yoksa = ay açık (default).
 *
 * BOSS ayı kapatıp açabilir. Her işlem audit log'a düşer.
 *
 * NOT: Şu an "kilitleme" işlevi sadece UI'da bilgi amaçlı.
 * Sorumlu paneli ileride eklenince servisler bu durumu kontrol edecek
 * (BOSS her zaman bypass edebilir).
 */

import { doc, getDoc, setDoc, arrayUnion, Timestamp } from 'firebase/firestore'
import { getFirestoreDb } from '@/lib/firebase'
import { nowServer } from '@/lib/firestore'
import type { FsTimestamp } from '@/types'

const KAPANIS = 'ayKapanislari'

export interface AyIslem {
  tip: 'kapama' | 'acma'
  tarih: FsTimestamp
  kullaniciId: string
  sebep?: string
}

export interface AyKapanisi {
  donem: string
  kapali: boolean
  sonIslem?: AyIslem
  islemler: AyIslem[]  // tüm geçmiş
}

export async function ayDurumu(donem: string): Promise<AyKapanisi> {
  const db = getFirestoreDb()
  const ref = doc(db, KAPANIS, donem)
  const snap = await getDoc(ref)
  if (!snap.exists()) {
    return { donem, kapali: false, islemler: [] }
  }
  const data = snap.data() as { kapali: boolean; sonIslem?: AyIslem; islemler?: AyIslem[] }
  return {
    donem,
    kapali: data.kapali ?? false,
    sonIslem: data.sonIslem,
    islemler: data.islemler ?? [],
  }
}

export async function ayKapat(
  donem: string,
  kullaniciId: string,
  sebep?: string
): Promise<void> {
  const db = getFirestoreDb()
  const ref = doc(db, KAPANIS, donem)
  const islem: Record<string, unknown> = {
    tip: 'kapama',
    tarih: Timestamp.now(),
    kullaniciId,
  }
  if (sebep?.trim()) islem.sebep = sebep.trim()

  // setDoc with merge — doc yoksa oluşturur
  await setDoc(
    ref,
    {
      donem,
      kapali: true,
      sonIslem: islem,
      islemler: arrayUnion(islem),
      guncellemeTarihi: nowServer(),
    },
    { merge: true }
  )
}

export async function ayAc(
  donem: string,
  kullaniciId: string,
  sebep?: string
): Promise<void> {
  const db = getFirestoreDb()
  const ref = doc(db, KAPANIS, donem)
  const islem: Record<string, unknown> = {
    tip: 'acma',
    tarih: Timestamp.now(),
    kullaniciId,
  }
  if (sebep?.trim()) islem.sebep = sebep.trim()

  await setDoc(
    ref,
    {
      donem,
      kapali: false,
      sonIslem: islem,
      islemler: arrayUnion(islem),
      guncellemeTarihi: nowServer(),
    },
    { merge: true }
  )
}
